import { render, staticRenderFns } from "./DurationSelector.vue?vue&type=template&id=9d7b20e2"
import script from "./DurationSelector.vue?vue&type=script&lang=js"
export * from "./DurationSelector.vue?vue&type=script&lang=js"
import style0 from "./DurationSelector.vue?vue&type=style&index=0&id=9d7b20e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports